import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { MENSAJE_ALERTA_TYPE } from 'types/MENSAJE_ALERTA_TYPE';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& > * + *': {
    },
  },
}));

const MensajeAlerta = ({categoria, mensaje, close, limpia}) => {
    const classes = useStyles();
   
    const state= {
      vertical: 'top',
      horizontal: 'center',
    };
  
    const { vertical, horizontal } = state;
    const [open, setOpen] = React.useState(true);
  
 
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    }; 

  useEffect (()=>{
    setOpen(true);
    if (close) {
      close(true)
    }
    if (limpia){
      limpia()
    }
  },[]);
  
  return (
    <div className={classes.root}>
    {categoria === MENSAJE_ALERTA_TYPE.Exito &&
          <>   
          <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} 
          open={open} 
          onClose={handleClose} 
          autoHideDuration={7000} 
          key={vertical + horizontal}
          >      
            <Alert onClose={handleClose} variant="filled" severity="success" style={{backgroundColor: "#0B3845"}}> 
              {mensaje}
            </Alert>
        </Snackbar> 
        </>
    }
    {categoria === MENSAJE_ALERTA_TYPE.Error &&
        <>         
          <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} onClose={handleClose} autoHideDuration={7000} key={vertical + horizontal}> 
            <Alert onClose={handleClose} variant="filled" severity="error" style={{backgroundColor: "#E76F51"}} >
              {mensaje}
            </Alert>
          </Snackbar> 
        </>   
    }
    {categoria === MENSAJE_ALERTA_TYPE.Warning &&
        <>         
          <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} onClose={handleClose} autoHideDuration={7000} key={vertical + horizontal}> 
            <Alert onClose={handleClose} variant="filled" severity="warning" style={{backgroundColor: "#F4A261"}}>
              {mensaje}
            </Alert>
          </Snackbar> 
        </>   
      }
    </div>
  );
}


export default MensajeAlerta;